module.exports = __webpack_public_path__ + "img/energy.2dbda53c.jpg";